import * as actions from './slice'

const getMSATenantConfig = () => ({
  eventName: 'msaGetTenantConfig',
  onSuccess: {
    action: actions.getMSATenantConfig,
    redux: true
  }
})

export {
  getMSATenantConfig
}
